import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CreateCustomer } from '../../../context/CustomerContext';
import { resetAllSlices } from '../../hooks/resetAllSlices';
import Admin from './Admin';

const AdminParent = () => {
    const location = useLocation();
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(resetAllSlices());

        return () => {
            dispatch(resetAllSlices());
        };
    }, [location.pathname, dispatch]);

    return (
        <CreateCustomer>
            <Admin />
        </CreateCustomer>
    );
};

export default AdminParent;
